import formatSize from './format-size-file/FormatSizeFileFilter';
import json from './json/JsonFilter';

const filters = { formatSize, json };

export default filters;